import { ref, readonly } from 'vue'

const toasts = ref([])
let toastId = 0

export function useToast() {
  const defaultDuration = 5000

  const addToast = ({
    type = 'info',
    title = '',
    message = '',
    duration = defaultDuration,
    dismissible = true
  }) => {
    const id = ++toastId

    const toast = {
      id,
      type,
      title,
      message,
      duration,
      dismissible,
      createdAt: Date.now()
    }

    toasts.value.push(toast)

    // Auto dismiss
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }

    return id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAll = () => {
    toasts.value = []
  }

  // Convenience methods
  const success = (title, message = '', options = {}) => {
    return addToast({ type: 'success', title, message, ...options })
  }

  const error = (title, message = '', options = {}) => {
    return addToast({ type: 'error', title, message, ...options })
  }

  const warning = (title, message = '', options = {}) => {
    return addToast({ type: 'warning', title, message, ...options })
  }

  const info = (title, message = '', options = {}) => {
    return addToast({ type: 'info', title, message, ...options })
  }

  return {
    toasts: readonly(toasts),
    addToast,
    removeToast,
    clearAll,
    success,
    error,
    warning,
    info
  }
}
